export var HooksOptions;
(function (HooksOptions) {
    HooksOptions["NO_HOOKS"] = "NO_HOOKS";
    HooksOptions["HOOKS_ONLY"] = "HOOKS_ONLY";
    HooksOptions["HOOKS_INCLUSIVE"] = "HOOKS_INCLUSIVE";
})(HooksOptions || (HooksOptions = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaG9va3NPcHRpb25zLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3V0aWwvaG9va3NPcHRpb25zLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE1BQU0sQ0FBTixJQUFZLFlBSVg7QUFKRCxXQUFZLFlBQVk7SUFDdEIscUNBQXFCLENBQUE7SUFDckIseUNBQXlCLENBQUE7SUFDekIsbURBQW1DLENBQUE7QUFDckMsQ0FBQyxFQUpXLFlBQVksS0FBWixZQUFZLFFBSXZCIn0=